import ContadoresView from './ContadoresView.vue'
import CreacionContadorView from './CreacionContadorView.vue'
import EdicionContadorView from './EdicionContadorView.vue'
import RegistroContadorView from './RegistroContadorView.vue'

export default [
  {
    path: '',
    meta: { requiresAuth: true },
    component: ContadoresView
  },
  {
    path: 'nuevo',
    meta: { requiresAuth: true },
    component: CreacionContadorView
  },
  {
    path: 'edicion/:id',
    meta: { requiresAuth: true },
    component: EdicionContadorView
  },
  {
    path: 'registra-contador',
    component: RegistroContadorView
  },
];